/**
 * Belo Email Protection
 * 
 * This script protects email addresses from being scraped by bots.
 * It works by:
 * 1. Splitting email addresses into parts
 * 2. Replacing mailto links with safe alternatives
 * 3. Reconstructing the email address when a user clicks
 */

document.addEventListener('DOMContentLoaded', function() {
  // Configuration
  const emailConfig = {
    user: 'support',
    domain: 'trybelo.com'
  };

  // Find and protect all email links
  const protectEmailLinks = function() {
    // Select all mailto links containing our email
    const emailLinks = document.querySelectorAll('a[href*="mailto:' + emailConfig.user + '@' + emailConfig.domain + '"]');
    
    // Process each link
    emailLinks.forEach(function(link) {
      // Replace the href to prevent scraping
      link.setAttribute('href', '#contact-us');
      
      // Add click handler to reconstruct email when clicked
      link.addEventListener('click', function(e) {
        e.preventDefault();
        window.location.href = 'mailto:' + emailConfig.user + '@' + emailConfig.domain;
      });
    });
  };

  // Find and protect plain text email mentions
  const protectEmailText = function() {
    // Find all text nodes in the document
    const findTextNodes = function(element) {
      let textNodes = [];
      const walk = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false);
      let node;
      while (node = walk.nextNode()) {
        textNodes.push(node);
      }
      return textNodes;
    };
    
    // Get all text nodes in the body
    const textNodes = findTextNodes(document.body);
    
    // Regular expression to find the email
    const emailRegex = new RegExp(emailConfig.user + '@' + emailConfig.domain, 'g');
    
    // Process each text node
    textNodes.forEach(function(node) {
      if (node.nodeValue && node.nodeValue.includes(emailConfig.user + '@' + emailConfig.domain)) {
        // Create a temporary element
        const temp = document.createElement('div');
        
        // Set its content to the text node's value
        temp.innerHTML = node.nodeValue;
        
        // Replace the email with a safer version
        temp.innerHTML = temp.innerHTML.replace(
          emailRegex,
          '<span class="protected-email"><span>' + emailConfig.user + '</span><span>&#64;</span><span>' + emailConfig.domain + '</span></span>'
        );
        
        // Create a document fragment from the HTML
        const fragment = document.createDocumentFragment();
        const div = document.createElement('div');
        div.innerHTML = temp.innerHTML;
        
        // Move all children to the fragment
        while (div.firstChild) {
          fragment.appendChild(div.firstChild);
        }
        
        // Replace the text node with the fragment
        const parent = node.parentNode;
        parent.replaceChild(fragment, node);
      }
    });
  };

  // Run protection functions
  protectEmailLinks();
  protectEmailText();
});
